import React, { useState } from "react";
import { Modal } from "antd";

const bodyStyle = {
  padding: "12px",
  background: "#f5f7fa",
  border: "1px solid #dce3eb",
  borderRadius: "6px",
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  maxHeight: "320px",
  overflow: "auto",
  fontSize: "12px",
};

const Body = ({ body, truncated }) => (
  <>
    <pre style={bodyStyle}>{body || "(empty body)"}</pre>
    {truncated && <p>Showing the first 64 KiB of this body.</p>}
  </>
);

export default function CrmImportDiagnostics({ diagnostics, borrowerId, source }) {
  const [open, setOpen] = useState(false);
  if (!diagnostics) return null;
  const { request, response, connection_error: connectionError } = diagnostics;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          border: 0,
          background: "none",
          color: "#0e5aa5",
          textDecoration: "underline",
          padding: "4px 0",
          cursor: "pointer",
          fontSize: "12px",
        }}
      >
        View CRM request and response
      </button>
      <Modal
        title={`CRM import diagnostics — ${borrowerId} (${source})`}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <p>
          Credentials and sensitive identity fields are redacted. JSON bodies are
          formatted for readability. Details are kept only on this page.
        </p>
        <p>
          Request ID: <code>{diagnostics.request_id}</code>
          <br />
          Elapsed: {diagnostics.elapsed_ms} ms
        </p>
        <h3>Request sent to CRM</h3>
        <p style={{ overflowWrap: "anywhere" }}>
          <strong>{request.method}</strong> {request.url}
          <br />
          Connection timeout: {request.connect_timeout_seconds}s; total timeout:{" "}
          {request.timeout_seconds}s
        </p>
        <h4>Request headers</h4>
        <pre style={bodyStyle}>{JSON.stringify(request.headers, null, 2)}</pre>
        <h4>Request body</h4>
        <Body body={request.body} truncated={request.body_truncated} />
        <h3>CRM response</h3>
        {response ? (
          <>
            <p>HTTP status: {response.status}</p>
            <h4>Response headers</h4>
            <pre style={bodyStyle}>
              {JSON.stringify(response.headers, null, 2)}
            </pre>
            <h4>Response body</h4>
            <Body body={response.body} truncated={response.body_truncated} />
          </>
        ) : (
          <p>No HTTP response was received from CRM.</p>
        )}
        {connectionError && (
          <>
            <h4>Connection error</h4>
            <pre style={bodyStyle}>{connectionError}</pre>
          </>
        )}
      </Modal>
    </>
  );
}
